import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComissaoListarComponent } from './comissao-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: ComissaoListarComponent}
  ])],
  exports: [RouterModule]
})
export class ComissaoListarRoutingModule { }
